require.register("ffss/ui/Modal", function(exports, require, module){
  $0
  
});

